module.exports = __webpack_public_path__ + "media/conversa/ico_sofia-61bd62f6.png";